var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-div",staticStyle:{"width":"100%","height":"100%"}},[_c('Echart',{ref:"chart",staticStyle:{"width":"100%","height":"100%"},attrs:{"chartOptions":_vm.options,"isData":_vm.isData},on:{"chartClick":_vm.chartClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }